import { UnderTitle } from "./SubTitle.style"
function SubTitle({text}) {
    return (
        <UnderTitle>{text}</UnderTitle>
    )
}

export default SubTitle